import React from "react";

import Layout from "../components/indexLayout";

const IndexPage = () => <Layout />;

export default IndexPage;
